import { requestJson } from '../@widgets/shared/request';
import type { PublicConfig } from '../shared/interfaces';
import { once } from '../shared/once';

export const getPublicConfig = once<Promise<PublicConfig>>(async () => {
    return requestJson({
        apiUrl: window.mh.apiUrl,
        endpoint: `/v1/programs/${window.mh.programSlug}/public-config`,
        method: `GET`,
    });
});
